export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_amzReplenishmentNo') || '亚马逊补货单号',
    field: 'amzReplenishmentNo',
    minWidth: 150,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_replenishmentStatus') || '单据状态',
    field: 'replenishmentStatus',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('form_label_planNo') || '补货计划编号',
    field: 'planNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_amzPeriodTitle') || '补货计划标题',
    field: 'amzPeriodTitle',
    minWidth: 270,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_shipPlanType') || '发运计划类型',
    field: 'v_shipPlanType',
    minWidth: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_skuSalesChannel') || '产品售卖渠道',
    field: 'skuSalesChannel',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'skuSalesChannel' },
  },
  {
    title: that.$l('form_label_shipPlanRange') || '补货范围',
    field: 'v_shipPlanRange',
    minWidth: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_replenishmentDateRange') || '补货填报日期范围',
    minWidth: 230,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
    slots: { default: 'replenishmentDateRange' },
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
